import { Box, Button as ThemeButton, ButtonProps as ThemeButtonProps, Spinner, SpinnerProps } from 'theme-ui';
import React from 'react';

import Icon, { IconName, IconProps } from '../Icon';

export interface ButtonProps extends ThemeButtonProps {
  loading?: boolean;
  spinnerProps?: Omit<SpinnerProps, 'ref'>;
  leadingIcon?: IconName;
  leadingIconProps?: Omit<IconProps, 'icon'>;
  trailingIcon?: IconName;
  trailingIconProps?: Omit<IconProps, 'icon'>;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      leadingIcon,
      leadingIconProps,
      loading,
      spinnerProps,
      trailingIcon,
      trailingIconProps,
      sx,
      variant,
      ...props
    },
    ref
  ) => (
    <ThemeButton
      {...props}
      ref={ref}
      variant={variant}
      sx={{
        ...(variant?.startsWith('text') && !leadingIcon && !trailingIcon
          ? {
              textDecoration: 'underline'
            }
          : {}),
        ...sx
      }}
    >
      {leadingIcon && (
        <Box as="span" sx={{ display: 'inline-flex', mr: 'xs' }}>
          <Icon icon={leadingIcon} role="img" sx={{ color: 'inherit' }} {...leadingIconProps} />
        </Box>
      )}
      {children}
      {trailingIcon && (
        <Box as="span" sx={{ display: 'inline-flex', ml: 'xs' }}>
          <Icon icon={trailingIcon} role="img" sx={{ color: 'inherit' }} {...trailingIconProps} />
        </Box>
      )}
      {loading && (
        <Spinner
          role="img"
          sx={{ display: 'inline-flex', ml: 'xs', color: 'inherit' }}
          size={spinnerProps?.size || variant?.startsWith('rounded') ? 16 : 24}
          {...spinnerProps}
        />
      )}
    </ThemeButton>
  )
);

Button.displayName = 'Button';

Button.defaultProps = {
  as: 'button',
  leadingIcon: undefined,
  loading: false,
  spinnerProps: {},
  trailingIcon: undefined
};

export default Button;
